import { ArrowLeft, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ScreenHeader = ({ title, onBack, variant = "back", testId }) => {
  const nav = useNavigate();
  const handle = onBack || (() => nav(-1));
  const Icon = variant === "close" ? X : ArrowLeft;
  return (
    <div className="flex items-center justify-between px-6 pt-4 pb-2">
      <button
        data-testid={testId || "screen-back-btn"}
        onClick={handle}
        className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 dark:hover:bg-white/10 active:scale-95 transition-all"
      >
        <Icon className="w-5 h-5 text-gray-900 dark:text-white" strokeWidth={2.2} />
      </button>
      {title && (
        <div className="font-display text-[15px] font-semibold text-gray-900 dark:text-white">
          {title}
        </div>
      )}
      <div className="w-10 h-10" />
    </div>
  );
};

export default ScreenHeader;
